import { createContext, useContext, useMemo } from "react";
import { useParams } from "react-router-dom";
import ec from "@/i18n/ec.json";
import en from "@/i18n/en.json";

const dictionaries = { ec, en };

const I18nContext = createContext({ lang: "ec", t: (k) => k });

export const I18nProvider = ({ children }) => {
  const { lang: paramLang } = useParams();
  const lang = paramLang === "en" ? "en" : "ec";
  const dict = dictionaries[lang];

  const value = useMemo(() => {
    const t = (key) => {
      if (!key) return "";
      const parts = key.split(".");
      let cur = dict;
      for (const p of parts) {
        if (cur && typeof cur === "object" && p in cur) {
          cur = cur[p];
        } else {
          return key;
        }
      }
      return typeof cur === "string" ? cur : key;
    };
    return { lang, t };
  }, [lang, dict]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
